/* src/Pages/NoticesPage/components/NoticeEditModal.tsx */
import React, { useEffect, useRef, useState } from 'react';
import { Modal, Input, message } from 'antd';
import { Editor } from '@toast-ui/react-editor';
import { Notice } from '../../../Modules/Notice/Model/Notice';
import { useAppDispatch } from '../../../Modules/Presentation/hooks';
import { editNotice } from '../../../Modules/Notice/Presentation/actions';
import dayjs from 'dayjs';

interface Props {
  open: boolean;
  notice: Notice | null;
  onClose: () => void;
}

const toolbar = [
  ['bold', 'italic', 'strike'],
  ['ul', 'ol', 'hr'],
  ['quote', 'table'],
];

const NoticeEditModal: React.FC<Props> = ({ open, notice, onClose }) => {
  const dispatch = useAppDispatch();
  const editorRef = useRef<Editor>(null);

  const [title, setTitle] = useState('');

  /* notice 가 바뀔 때 제목 필드 초기화 */
  useEffect(() => { setTitle(notice?.title ?? ''); }, [notice]);

  /* ---- 저장 ---- */
  const handleSubmit = async () => {
    if (!notice) return;
    const md = editorRef.current?.getInstance().getMarkdown() ?? '';

    if (!title.trim()) { message.warning('제목을 입력하세요'); return; }
    if (!md.trim()) { message.warning('내용을 입력하세요'); return; }

    try {
      await dispatch(editNotice({ id: notice.noticeId, dto: { title, content: md } })).unwrap();
      message.success('수정이 완료되었습니다');
      onClose();
    } catch { message.error('수정에 실패하였습니다.'); }
  };

  /* ---- 닫기 ---- */
  const handleCancel = () => {
    setTitle(notice?.title ?? '');
    onClose();
  };

  return (
    <Modal
      open={open}
      destroyOnClose
      width={860}
      title={`공지 수정${notice ? ` (ID: ${notice.noticeId})` : ''}`}
      onOk={handleSubmit}
      onCancel={handleCancel}
      okText="수정"
    >
      {notice && (
        <>
          <div style={{ fontSize: 13, color: '#666', marginBottom: 4 }}>
            작성일 {dayjs(notice.created_at).format('YYYY-MM-DD')}
          </div>

          {/* 제목 */}
          <label>제목</label>
          <Input
            value={title}
            onChange={e => setTitle(e.target.value)}
            placeholder="제목을 입력하세요"
            style={{ marginBottom: 16 }}
          />

          {/* 내용 */}
          <label>내용</label>
          <Editor
            key={notice.noticeId}
            ref={editorRef}
            initialValue={notice.content}
            height="420px"
            initialEditType="wysiwyg"
            hideModeSwitch
            toolbarItems={toolbar}
            usageStatistics={false}
            hooks={{ addImageBlobHook: () => false }}  
          />
        </>
      )}
    </Modal>
  );
};

export default NoticeEditModal;
